<template>
<div class="settings">
  <div @click="openModal" class="settings__trigger">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.6026 1.09072C10.9666 -0.363576 13.0334 -0.363573 13.3974 1.09072L13.5046 1.51932C13.779 2.61567 15.1515 2.98341 15.9373 2.17115L16.2445 1.8536C17.2869 0.776145 19.0767 1.80952 18.6648 3.25097L18.5434 3.67579C18.2329 4.76245 19.2376 5.76714 20.3242 5.4566L20.749 5.33521C22.1905 4.92329 23.2239 6.71314 22.1464 7.75552L21.8289 8.06272C21.0166 8.84853 21.3843 10.221 22.4807 10.4954L22.9093 10.6026C24.3636 10.9666 24.3636 13.0334 22.9093 13.3974L22.4807 13.5046C21.3843 13.779 21.0166 15.1515 21.8289 15.9373L22.1464 16.2445C23.2239 17.2869 22.1905 19.0767 20.749 18.6648L20.3242 18.5434C19.2376 18.2329 18.2329 19.2376 18.5434 20.3242L18.6648 20.749C19.0767 22.1905 17.2869 23.2239 16.2445 22.1464L15.9373 21.8289C15.1515 21.0166 13.779 21.3843 13.5046 22.4807L13.3974 22.9093C13.0334 24.3636 10.9666 24.3636 10.6026 22.9093L10.4954 22.4807C10.221 21.3843 8.84853 21.0166 8.06272 21.8289L7.75552 22.1464C6.71314 23.2239 4.92329 22.1905 5.33521 20.749L5.45661 20.3242C5.76714 19.2376 4.76245 18.2329 3.67578 18.5434L3.25097 18.6648C1.80951 19.0767 0.776148 17.2869 1.85361 16.2445L2.17115 15.9373C2.98341 15.1515 2.61566 13.779 1.51932 13.5046L1.09072 13.3974C-0.363576 13.0334 -0.363573 10.9666 1.09072 10.6026L1.51932 10.4954C2.61567 10.221 2.98341 8.84853 2.17115 8.06272L1.85361 7.75552C0.776146 6.71314 1.80952 4.92329 3.25097 5.33521L3.67579 5.45661C4.76245 5.76714 5.76714 4.76245 5.4566 3.67578L5.33521 3.25097C4.92329 1.80951 6.71314 0.776149 7.75552 1.85361L8.06272 2.17115C8.84853 2.98341 10.221 2.61566 10.4954 1.51932L10.6026 1.09072ZM19.4595 12.7497H12.3748L8.12371 18.4178C9.25478 19.1025 10.5814 19.4965 12 19.4965C15.8872 19.4965 19.0833 16.5379 19.4595 12.7497ZM19.4595 11.2504C19.0833 7.46218 15.8872 4.50356 12 4.50356C10.5814 4.50356 9.25478 4.89761 8.12371 5.58224L12.3748 11.2504H19.4595ZM7.57191 5.95051C7.52809 5.98264 7.48462 6.01524 7.44153 6.04829L7.57191 5.95051ZM6.92492 6.48267C5.43628 7.85269 4.50352 9.81743 4.50352 12C4.50352 14.1826 5.43628 16.1474 6.92492 17.5174L11.0629 12L6.92492 6.48267ZM7.44151 17.9518C7.48462 17.9848 7.5281 18.0174 7.57194 18.0496L7.44151 17.9518Z" fill="var(--new-front-adv-font-color)"/>
    </svg>
  </div>
  <transition name="slide-fade">
    <div v-show="isModalOpen" v-click-outside="closeModal" class="settings__modal">
      <div class="settings__modal__header">
        <div class="settings__modal__header-title">{{ $t('settings-modal.title') }}</div>
        <div class="settings__modal__header-email">{{ user.email }}</div>
      </div>
      <div class="settings__modal-items">
        <div class="settings__modal-item">
          <div class="settings__modal-item__left">
            <Icon class="icon" :icon="'moon'" />
            <span class="settings__modal-item__title">{{ $t('settings-modal.dark-theme') }}</span>
          </div>
          <div class="settings__modal-item__right">
            <Toggle :value="themeStatus"  @change="toggleTheme($event)"/>
          </div>
        </div>
        <RouterLink to="/organizations" @click.native="closeModal">
          <div class="settings__modal-item">
            <div class="settings__modal-item__left">
              <Icon :icon="'briefcase'" />
              <span class="settings__modal-item__title">{{ $t('settings-modal.business-settings') }}</span>
            </div>
          </div>
        </RouterLink>
          <RouterLink to="/collecting-profits" @click.native="closeModal">
          <div class="settings__modal-item">
              <div class="settings__modal-item__left">
                  <Icon :icon="'collect'" />
                  <span class="settings__modal-item__title">{{ $t('settings-modal.collect') }}</span>
              </div>
          </div>
          </RouterLink>
        <div @click="openLanguagesModal" class="settings__modal-item">
          <div class="settings__modal-item__left">
            <Icon :icon="'language'" />
            <span class="settings__modal-item__title">{{ $t('settings-modal.language') }}</span>
          </div>
          <div class="settings__modal-item__right">
            {{ langLabel }}
          </div>
        </div>
        <a v-if="amlPolicyLink"  v-bind:href="amlPolicyLink" target="_blank" class="settings__modal-item" @click="closeModal">
          <div class="settings__modal-item__left">
            <Icon :icon="'folder'" />
            <span class="settings__modal-item__title">{{ $t('settings-modal.aml-policy') }}</span>
          </div>
        </a>
        <a href="/logout">
          <div class="settings__modal-item">
            <div class="settings__modal-item__left">
              <Icon :icon="'logout'" />
              <span class="settings__modal-item__title">{{ $t('settings-modal.logout') }}</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </transition>

</div>
</template>

<script>
  import Toggle from "../Toggle";
  import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
  import Icon from "../../common/uiKit/Icon";
  import LanguageSwitcher from "../../common/LanguageSwitcher";
  import vClickOutside from 'v-click-outside'
  const languages = [
      'English',
      'Русский'
  ]
  export default {
    name: "HeaderSettings",
    components: {LanguageSwitcher, Icon, Toggle},
    directives: {
      clickOutside: vClickOutside.directive
    },
    languages,
    data () {
      return {
        themeStatus: false,
        lightMode: 'light',
        darkMode: 'dark',
        isModalOpen: false,
          amlPolicyLink: import.meta.env.VITE_AML_POLICY_LINK
      }
    },
    created() {
      let theme = localStorage.getItem('data-theme-private');

      this.themeStatus = theme === 'dark';
      document.documentElement.setAttribute("data-theme-private", theme);
    },
    methods: {
      ...mapMutations('app', ['setTheme']),
      openModal () {
        this.isModalOpen = true
      },
      closeModal (event) {
        // if (event?._prevClass === 'settings__trigger' || event?.parentElement._prevClass === 'settings__trigger') return;
        if (event && (event.target.tagName === 'svg' || event.target.tagName === 'path' || event.target.className === 'settings__trigger')) return
        this.isModalOpen = false
      },
      toggleTheme(event) {
        const themeOsDark = window.matchMedia("(prefers-color-scheme: dark)");
        let theme = localStorage.getItem('data-theme-private');

          if (theme === 'dark') {
            this.themeStatus = false;
            document.documentElement.setAttribute("data-theme-private", this.lightMode);
            localStorage.setItem("data-theme-private", this.lightMode);
          } else if (theme === 'light') {
            this.themeStatus = true;
            document.documentElement.setAttribute("data-theme-private", this.darkMode);
            localStorage.setItem("data-theme-private", this.darkMode);
          } else {
            this.themeStatus = true;
            document.documentElement.setAttribute("data-theme-private", this.darkMode);
            localStorage.setItem("data-theme-private", this.darkMode);
          }
        this.setTheme(localStorage.getItem("data-theme-private")) //пишем тему в стор
        this.closeModal()
      },
      openLanguagesModal () {
        this.$emit('openLanguage')
        this.closeModal()
      }
    },
    computed: {
      ...mapState('user', [
        'lang',
        'user'
      ]),
        // ...mapGetters('organizations', ['userRoleRules']),
      langLabel () {
        return this.lang === 'en' ? this.$options.languages[0] : this.$options.languages[1]
      },
        // isCollectingShow () {
        //     return this.userRoleRules['collecting'].isAllowed
        // }
    }
  }
</script>

<style lang="scss" scoped>
.settings {
  position: relative;
  font-family: $Gilroy;
  &__trigger {
    background: var(--new-front-adv-bg);
    border: 1px var(--new-front-adv-border-color) solid;
    border-radius: 10px;
    height: 48px;
    width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      background: var(--new-front-adv-hover-bg);
    }
    &:active:hover {
      background: var(--new-front-adv-click-bg);
    }
  }
  &__modal {
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translateY(calc(100% + $p10));
    border: 1px var(--new-front-border-color) solid;
    background: var(--new-front-nav-bg);
    border-radius: 10px;
    width: 355px;
    &__header {
      padding: $p15 $p20;
      border-bottom: 1px var(--new-front-border-color) solid;
      &-title {
        font-size: $h4;
        color: var(--new-front-primary-font-color);
        margin-bottom: $p5;
      }
      &-email {
        font-size: $h6;
        color: var(--new-front-secondary-font-color);
      }
    }
    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: $p15 $p20;
      border-radius: 10px;
      transition: all .3s ease;
      cursor: pointer;
      &:hover {
        background: var(--new-font-nav-hover-bg);
          &::v-deep svg {
            path {
              fill: #744DB2 !important;
            }
          }
        .settings__modal-item__title {
          color: var(--new-front-primary-font-color);
        }
      }
      &__title {
        color: var(--new-front-secondary-font-color);
        font-size: $h4;
        margin-left: $p10;
        transition: color .3s ease;
      }
      &__left {
        display: flex;
        align-items: center;
        &::v-deep svg {
          path {
            fill: var(--new-front-secondary-font-color) !important;
          }
        }
      }
      &__right {
        color: var(--new-front-primary-font-color);
        font-size: $h4;
      }
    }
  }
}
.icon {
    &::v-deep svg {
      path {
        fill: var(--new-front-secondary-font-color) !important;
      }
    }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translate(10px, calc(100% + $p10));
  opacity: 0;
}

@media screen and (max-width: 575px) {
  .settings__modal {
    width: 310px;
    transform: translate(36px,calc(100% + 9px));
  }
}
@media screen and (max-width: 375px) {
  .settings__modal {
    width: 310px;
    transform: translate(46px,calc(100% + 9px));
  }
}
</style>
